import React from 'react';
import CameraViewIcon from './CameraViewIcon';

export const IconDefault = () => (
  <CameraViewIcon width="67.431" height="50.136" viewBox="0 20 67.431 50.136">
    <g transform="translate(3.529 21.383)">
      <path
        d="M7.126,4.049a.373.373,0,0,1-.172-.042L-.172.333A.375.375,0,0,1-.333-.172.375.375,0,0,1,.172-.333L7.3,3.341a.375.375,0,0,1-.172.708Z"
        transform="translate(1.484 36.24)"
        fill="currentColor"
      />
      <path
        d="M.017,1.09A.375.375,0,0,1-.358.724L-.375.009A.375.375,0,0,1-.009-.375a.375.375,0,0,1,.384.366L.392.706a.375.375,0,0,1-.366.384Z"
        transform="translate(8.61 39.914)"
        fill="currentColor"
      />
      <path
        d="M9.784,5.378a.373.373,0,0,1-.17-.041l-9.784-5a.375.375,0,0,1-.163-.5.375.375,0,0,1,.5-.163l9.784,5a.375.375,0,0,1-.171.709Z"
        transform="translate(8.627 40.629)"
        fill="currentColor"
      />
      <path
        d="M0,.494A.375.375,0,0,1-.34.277a.375.375,0,0,1,.182-.5L.1-.34a.375.375,0,0,1,.5.182.375.375,0,0,1-.182.5L.158.459A.374.374,0,0,1,0,.494Z"
        transform="translate(1.229 36.24)"
        fill="currentColor"
      />
      <g transform="translate(0 0)">
        <g transform="translate(0 0)" clipPath="url(#a)">
          <path
            d="M1.013.951A.373.373,0,0,1,.828.9L-.185.326A.375.375,0,0,1-.326-.185.375.375,0,0,1,.185-.326L1.2.25a.375.375,0,0,1-.186.7Z"
            transform="translate(0.215 35.783)"
            fill="currentColor"
          />
          <path
            d="M0,13.883a.375.375,0,0,1-.375-.375V0A.375.375,0,0,1,0-.375.375.375,0,0,1,.375,0V13.508A.375.375,0,0,1,0,13.883Z"
            transform="translate(0.215 22.275)"
            fill="currentColor"
          />
        </g>
      </g>
      <path
        d="M0,5.521a.375.375,0,0,1-.375-.375V0A.375.375,0,0,1,0-.375.375.375,0,0,1,.375,0V5.146A.375.375,0,0,1,0,5.521Z"
        transform="translate(41.397 30.348)"
        fill="currentColor"
      />
      <path
        d="M.013,5.563a.375.375,0,0,1-.375-.374L-.375,0A.375.375,0,0,1,0-.375.375.375,0,0,1,.375,0L.388,5.187A.375.375,0,0,1,.013,5.563Z"
        transform="translate(42.472 30.423)"
        fill="currentColor"
      />
      <path
        d="M0,13.86a.375.375,0,0,1-.375-.375V0A.375.375,0,0,1,0-.375.375.375,0,0,1,.375,0V13.485A.375.375,0,0,1,0,13.86Z"
        transform="translate(20.192 32.654)"
        fill="currentColor"
      />
      <path
        d="M1.073.9A.373.373,0,0,1,.908.864L-.165.337a.375.375,0,0,1-.171-.5.375.375,0,0,1,.5-.171L1.239.191A.375.375,0,0,1,1.073.9Z"
        transform="translate(20.192 46.139)"
        fill="currentColor"
      />
      <path
        d="M0,.761A.375.375,0,0,1-.335.555a.375.375,0,0,1,.166-.5L.594-.335a.375.375,0,0,1,.5.166.375.375,0,0,1-.166.5L.169.72A.373.373,0,0,1,0,.761Z"
        transform="translate(21.266 46.281)"
        fill="currentColor"
      />
      <path
        d="M0,13.918a.375.375,0,0,1-.375-.375V0A.375.375,0,0,1,0-.375.375.375,0,0,1,.375,0V13.543A.375.375,0,0,1,0,13.918Z"
        transform="translate(22.029 32.738)"
        fill="currentColor"
      />
      <path
        d="M0,1.034A.375.375,0,0,1-.375.658l0-.659A.375.375,0,0,1,0-.375.375.375,0,0,1,.378,0l0,.659A.375.375,0,0,1,0,1.034Z"
        transform="translate(62 24.855)"
        fill="currentColor"
      />
      <path
        d="M0,10.472a.375.375,0,0,1-.333-.2.375.375,0,0,1,.161-.505L19.343-.333a.375.375,0,0,1,.505.161.375.375,0,0,1-.161.505L.172,10.43A.373.373,0,0,1,0,10.472Z"
        transform="translate(42.485 25.514)"
        fill="currentColor"
      />
      <path
        d="M0,4.872A.375.375,0,0,1-.375,4.5V0A.375.375,0,0,1,0-.375.375.375,0,0,1,.375,0V4.5A.375.375,0,0,1,0,4.872Z"
        transform="translate(62.003 20.358)"
        fill="currentColor"
      />
      <path
        d="M.685.756A.373.373,0,0,1,.5.709L-.182.328a.375.375,0,0,1-.146-.51.375.375,0,0,1,.51-.146L.868.053a.375.375,0,0,1-.183.7Z"
        transform="translate(62.003 24.855)"
        fill="currentColor"
      />
      <g transform="translate(0 0)">
        <g transform="translate(0 0)" clipPath="url(#a)">
          <path
            d="M0,.756A.375.375,0,0,1-.341.536.375.375,0,0,1-.155.04L.683-.341a.375.375,0,0,1,.5.186.375.375,0,0,1-.186.5L.155.723A.374.374,0,0,1,0,.756Z"
            transform="translate(62.689 24.855)"
            fill="currentColor"
          />
        </g>
      </g>
      <path
        d="M0,13.789a.375.375,0,0,1-.375-.375V0A.375.375,0,0,1,0-.375.375.375,0,0,1,.375,0V13.414A.375.375,0,0,1,0,13.789Z"
        transform="translate(62.689 11.822)"
        fill="currentColor"
      />
      <path
        d="M0,3.271A.375.375,0,0,1-.375,2.9V0A.375.375,0,0,1,0-.375.375.375,0,0,1,.375,0V2.9A.375.375,0,0,1,0,3.271Z"
        transform="translate(41.654 0.999)"
        fill="currentColor"
      />
      <path
        d="M50.962,1.959a.375.375,0,0,1-.373-.337A1.134,1.134,0,0,1,50.838.79a.375.375,0,1,1,.583.471.388.388,0,0,0-.085.285A.375.375,0,0,1,51,1.957Z"
        transform="translate(-9.309 -0.585)"
        fill="currentColor"
      />
      <path
        d="M49.2,1.1A.375.375,0,0,1,48.91.492.988.988,0,0,1,50.131.237.375.375,0,1,1,49.785.9a.235.235,0,0,0-.291.06A.374.374,0,0,1,49.2,1.1Z"
        transform="translate(-7.381 -0.285)"
        fill="currentColor"
      />
      <path
        d="M20.622,11.117a.373.373,0,0,1-.173-.042L-.173.333A.375.375,0,0,1-.333-.173.375.375,0,0,1,.173-.333L20.8,10.409a.375.375,0,0,1-.174.708Z"
        transform="translate(42.576 0.284)"
        fill="currentColor"
      />
      <path
        d="M.828,26.545a.375.375,0,0,1-.375-.375.234.234,0,0,0-.126-.208A.375.375,0,1,1,.673,25.3a.981.981,0,0,1,.53.873A.375.375,0,0,1,.828,26.545Z"
        transform="translate(62.699 -14.604)"
        fill="currentColor"
      />
      <path
        d="M0,13.664a.375.375,0,0,1-.375-.375V0A.375.375,0,0,1,0-.375.375.375,0,0,1,.375,0V13.289A.375.375,0,0,1,0,13.664Z"
        transform="translate(63.527 11.566)"
        fill="currentColor"
      />
      <path
        d="M98.638,111.422l-.168,0a4.618,4.618,0,0,1-.825-.1,2.6,2.6,0,0,1-.64-.234,1.358,1.358,0,0,1-.687-.781.375.375,0,0,1,.69-.294c.127.3.225.349.337.406a1.867,1.867,0,0,0,.464.171,3.907,3.907,0,0,0,.686.081,3.471,3.471,0,0,0,.673-.038,2.469,2.469,0,0,0,.555-.149,1.013,1.013,0,0,0,.3-.19c.039-.036.083-.076.133-.373a.375.375,0,0,1,.74.124,1.21,1.21,0,0,1-.365.8,1.764,1.764,0,0,1-.513.328,3.233,3.233,0,0,1-.73.2A4.086,4.086,0,0,1,98.638,111.422Z"
        transform="translate(-78.366 -62.668)"
        fill="currentColor"
      />
      <path
        d="M.225,1.372A.375.375,0,0,1-.14,1.079l-.225-1A.375.375,0,0,1-.083-.366a.375.375,0,0,1,.448.283l.225,1a.375.375,0,0,1-.366.458Z"
        transform="translate(21.934 46.316)"
        fill="currentColor"
      />
      <path
        d="M17.316,69.664c-.087,0-.173,0-.259-.009a3.845,3.845,0,0,1-.569-.083,3.538,3.538,0,0,1-.511-.154,1.477,1.477,0,0,1-.49-.317.375.375,0,0,1,.5-.562.76.76,0,0,0,.266.181,2.781,2.781,0,0,0,.4.12,3.092,3.092,0,0,0,.458.066,3.229,3.229,0,0,0,.478,0,3.306,3.306,0,0,0,.523-.079,2.383,2.383,0,0,0,.441-.154.907.907,0,0,0,.243-.16c.049-.044.095-.084.112-.318a.375.375,0,1,1,.748.056,1.078,1.078,0,0,1-.361.822,1.658,1.658,0,0,1-.42.278,3.116,3.116,0,0,1-.584.206,4.053,4.053,0,0,1-.644.1C17.529,69.659,17.421,69.664,17.316,69.664Z"
        transform="translate(37.694 -38.872)"
        fill="currentColor"
      />
      <path
        d="M.22,1.493a.375.375,0,0,1-.368-.3L-.368.072a.375.375,0,0,1,.3-.44.375.375,0,0,1,.44.3l.22,1.118a.375.375,0,0,1-.368.448Z"
        transform="translate(56.753 28.229)"
        fill="currentColor"
      />
      <path
        d="M127.6,96.692a4.1,4.1,0,0,1-.738-.063,2.84,2.84,0,0,1-.738-.237,1.619,1.619,0,0,1-.537-.416,1.366,1.366,0,0,1-.252-.5.375.375,0,1,1,.716-.222.62.62,0,0,0,.115.248.864.864,0,0,0,.291.221,2.114,2.114,0,0,0,.54.171,3.412,3.412,0,0,0,.654.05,3.637,3.637,0,0,0,.6-.055,1.747,1.747,0,0,0,.427-.137c.1-.046.226-.1.556-.492a.375.375,0,1,1,.571.486,2.251,2.251,0,0,1-.815.688,2.517,2.517,0,0,1-.6.192,4.342,4.342,0,0,1-.734.068Z"
        transform="translate(-119.851 -54.338)"
        fill="currentColor"
      />
      <path
        d="M0,2.677A.377.377,0,0,1-.074,2.67a.375.375,0,0,1-.293-.442L.1-.074A.375.375,0,0,1,.539-.368.375.375,0,0,1,.832.074l-.465,2.3A.375.375,0,0,1,0,2.677Z"
        transform="translate(5.84 38.722)"
        fill="currentColor"
      />
      <path
        d="M0,1.228a.375.375,0,0,1-.333-.2A.375.375,0,0,1-.172.52l1.65-.853a.375.375,0,0,1,.505.161.375.375,0,0,1-.161.505l-1.65.853A.373.373,0,0,1,0,1.228Z"
        transform="translate(4.573 26.313)"
        fill="currentColor"
      />
      <path
        d="M0,18.555a.375.375,0,0,1-.333-.2.375.375,0,0,1,.161-.505L35.005-.333a.375.375,0,0,1,.505.161.375.375,0,0,1-.161.505L.172,18.514A.373.373,0,0,1,0,18.555Z"
        transform="translate(8.024 7.202)"
        fill="currentColor"
      />
      <path
        d="M0,2.808H-.028a.375.375,0,0,1-.346-.4L-.193-.028a.375.375,0,0,1,.4-.346.375.375,0,0,1,.346.4L.374,2.461A.375.375,0,0,1,0,2.808Z"
        transform="translate(18.297 45.058)"
        fill="currentColor"
      />
      <path
        d="M1.718,1.216a.373.373,0,0,1-.165-.038L-.165.337a.375.375,0,0,1-.172-.5.375.375,0,0,1,.5-.172L1.883.5a.375.375,0,0,1-.165.712Z"
        transform="translate(18.478 45.057)"
        fill="currentColor"
      />
      <path
        d="M99.839,75.4a.375.375,0,0,1-.371-.431,1.248,1.248,0,0,1,.244-.634.907.907,0,0,1,.287-.244.89.89,0,0,1,.3-.1.855.855,0,0,1,.162,0,.375.375,0,1,1-.048.748h-.02a.133.133,0,0,0-.044.015.168.168,0,0,0-.055.05.528.528,0,0,0-.088.278A.375.375,0,0,1,99.839,75.4Z"
        transform="translate(-79.647 -42.373)"
        fill="currentColor"
      />
      <path
        d="M18.708,10.026a.373.373,0,0,1-.172-.042L-.172.333A.375.375,0,0,1-.333-.172.375.375,0,0,1,.172-.333L18.88,9.317a.375.375,0,0,1-.172.708Z"
        transform="translate(1.484 25.958)"
        fill="currentColor"
      />
      <path
        d="M0,2.091a.375.375,0,0,1-.375-.375V0A.375.375,0,0,1,0-.375.375.375,0,0,1,.375,0V1.716A.375.375,0,0,1,0,2.091Z"
        transform="translate(2.024 24.138)"
        fill="currentColor"
      />
      <path
        d="M0,13.877A.375.375,0,0,1-.375,13.5V0A.375.375,0,0,1,0-.375.375.375,0,0,1,.375,0V13.5A.375.375,0,0,1,0,13.877Z"
        transform="translate(1.209 22.845)"
        fill="currentColor"
      />
      <path
        d="M146.282,51.326a.375.375,0,0,1-.374-.359.825.825,0,0,1,.143-.5,1.333,1.333,0,0,1,.178-.224,1.069,1.069,0,0,1,.214-.168.826.826,0,0,1,.428-.122.375.375,0,0,1,.021.75.1.1,0,0,0-.062.014.329.329,0,0,0-.069.054.588.588,0,0,0-.079.1c-.026.041-.026.047-.025.066a.375.375,0,0,1-.359.391Z"
        transform="translate(-146.067 -28.676)"
        fill="currentColor"
      />
      <path
        d="M143.7,52.645a.375.375,0,0,1-.366-.458,1.29,1.29,0,0,1,.232-.545.863.863,0,0,1,.221-.216.836.836,0,0,1,.267-.115,1.123,1.123,0,0,1,.208-.025.375.375,0,0,1,.046.749c-.017,0-.069,0-.08.006a.1.1,0,0,0-.029.011.263.263,0,0,0-.035.042.586.586,0,0,0-.1.258A.375.375,0,0,1,143.7,52.645Z"
        transform="translate(-142.365 -29.437)"
        fill="currentColor"
      />
      <path
        d="M18.881,10.159a.373.373,0,0,1-.172-.042L-.173.333a.375.375,0,0,1-.16-.505.375.375,0,0,1,.505-.16L19.054,9.45a.375.375,0,0,1-.173.708Z"
        transform="translate(1.338 23.782)"
        fill="currentColor"
      />
      <path
        d="M21.094,11.295a.373.373,0,0,1-.172-.042L-.172.333A.375.375,0,0,1-.333-.172.375.375,0,0,1,.172-.333l21.095,10.92a.375.375,0,0,1-.173.708Z"
        transform="translate(0.815 21.65)"
        fill="currentColor"
      />
      <path transform="translate(-3.529 -9.449)" fill="currentColor" />
      <path
        d="M0,10.336a.375.375,0,0,1-.334-.2.375.375,0,0,1,.162-.5L19.2-.333a.375.375,0,0,1,.5.162.375.375,0,0,1-.162.5L.172,10.294A.373.373,0,0,1,0,10.336Z"
        transform="translate(22.029 30.348)"
        fill="currentColor"
      />
      <path
        d="M0,10.369a.375.375,0,0,1-.334-.2.375.375,0,0,1,.161-.505L19.2-.333a.375.375,0,0,1,.505.161.375.375,0,0,1-.161.505L.172,10.327A.373.373,0,0,1,0,10.369Z"
        transform="translate(22.029 35.494)"
        fill="currentColor"
      />
      <path
        d="M0,20.526a.375.375,0,0,1-.333-.2.375.375,0,0,1,.161-.505L38.841-.333a.375.375,0,0,1,.505.161.375.375,0,0,1-.161.505L.172,20.484A.373.373,0,0,1,0,20.526Z"
        transform="translate(22.029 16.305)"
        fill="currentColor"
      />
      <path transform="translate(54.638 -21.383)" fill="currentColor" />
      <path
        d="M17.241,9.309a.373.373,0,0,1-.172-.042L-.173.333a.375.375,0,0,1-.16-.505.375.375,0,0,1,.505-.16L17.414,8.6a.375.375,0,0,1-.173.708Z"
        transform="translate(43.639 7.209)"
        fill="currentColor"
      />
      <path
        d="M0,2.495H0a.375.375,0,0,1-.372-.378L-.357,0A.375.375,0,0,1,.021-.375.375.375,0,0,1,.393,0L.375,2.123A.375.375,0,0,1,0,2.495Z"
        transform="translate(61.038 16.542)"
        fill="currentColor"
      />
      <path
        d="M0,3.6a.375.375,0,0,1-.375-.375V0A.375.375,0,0,1,0-.375.375.375,0,0,1,.375,0V3.225A.375.375,0,0,1,0,3.6Z"
        transform="translate(22.457 14.672)"
        fill="currentColor"
      />
      <path
        d="M0,3.244a.375.375,0,0,1-.375-.375V0A.375.375,0,0,1,0-.375.375.375,0,0,1,.375,0V2.869A.375.375,0,0,1,0,3.244Z"
        transform="translate(23.558 14.505)"
        fill="currentColor"
      />
      <path
        d="M0,.753A.375.375,0,0,1-.322.57.375.375,0,0,1-.192.055L.443-.322a.375.375,0,0,1,.514.13.375.375,0,0,1-.13.514L.192.7A.373.373,0,0,1,0,.753Z"
        transform="translate(40.979 5.094)"
        fill="currentColor"
      />
      <path
        d="M0,3.259a.375.375,0,0,1-.375-.375V0A.375.375,0,0,1,0-.375.375.375,0,0,1,.375,0V2.884A.375.375,0,0,1,0,3.259Z"
        transform="translate(40.979 5.472)"
        fill="currentColor"
      />
      <path
        d="M0,3.283a.375.375,0,0,1-.375-.375V0A.375.375,0,0,1,0-.375.375.375,0,0,1,.375,0V2.908A.375.375,0,0,1,0,3.283Z"
        transform="translate(41.613 5.094)"
        fill="currentColor"
      />
      <path
        d="M.985.865A.373.373,0,0,1,.818.826L-.167.336a.375.375,0,0,1-.169-.5.375.375,0,0,1,.5-.169l.985.49A.375.375,0,0,1,.985.865Z"
        transform="translate(21.665 14.278)"
        fill="currentColor"
      />
      <path
        d="M96.462,33.381a.375.375,0,0,1-.365-.462.376.376,0,0,0,.01-.113.28.28,0,0,0-.021-.093.472.472,0,0,0-.094-.122.8.8,0,0,0-.136-.115l-.008,0v.006a.375.375,0,0,1-.746.077,1.274,1.274,0,0,1,.006-.286.824.824,0,0,1,.092-.309.618.618,0,0,1,.412-.318.677.677,0,0,1,.451.095l.027.014c.054.028.11.056.169.094a1.518,1.518,0,0,1,.268.222,1.168,1.168,0,0,1,.242.338,1.018,1.018,0,0,1,.085.35,1.125,1.125,0,0,1-.029.339A.375.375,0,0,1,96.462,33.381Z"
        transform="translate(-73.811 -18.238)"
        fill="currentColor"
      />
      <path
        d="M0,10.488a.375.375,0,0,1-.333-.2.375.375,0,0,1,.159-.506L19.251-.333a.375.375,0,0,1,.506.159A.375.375,0,0,1,19.6.333L.173,10.446A.373.373,0,0,1,0,10.488Z"
        transform="translate(22.65 4.654)"
        fill="currentColor"
      />
      <path
        d="M0,10.353a.375.375,0,0,1-.334-.2.375.375,0,0,1,.161-.505L19.169-.333a.375.375,0,0,1,.505.161.375.375,0,0,1-.161.505L.172,10.312A.373.373,0,0,1,0,10.353Z"
        transform="translate(21.873 3.794)"
        fill="currentColor"
      />
      <path
        d="M51.23,10.036a.375.375,0,0,1-.374-.352.475.475,0,0,0-.038-.168.822.822,0,0,0-.141-.186.91.91,0,0,0-.153-.14.234.234,0,0,0-.053-.028h0a.375.375,0,0,1-.19-.725.774.774,0,0,1,.206-.026.842.842,0,0,1,.457.154,1.6,1.6,0,0,1,.289.254A1.482,1.482,0,0,1,51.5,9.2a1.21,1.21,0,0,1,.106.437.375.375,0,0,1-.351.4Z"
        transform="translate(-9.156 -5.006)"
        fill="currentColor"
      />
      <path
        d="M0,8.078A.375.375,0,0,1-.375,7.7V0A.375.375,0,0,1,0-.375.375.375,0,0,1,.375,0V7.7A.375.375,0,0,1,0,8.078Z"
        transform="translate(61.622 11.212)"
        fill="currentColor"
      />
      <path
        d="M0,10.4a.375.375,0,0,1-.333-.2.375.375,0,0,1,.161-.505L19.187-.333a.375.375,0,0,1,.505.161.375.375,0,0,1-.161.505L.172,10.354A.373.373,0,0,1,0,10.4Z"
        transform="translate(41.577 18.681)"
        fill="currentColor"
      />
      <path
        d="M50.41,68.06a.375.375,0,0,1-.366-.459.548.548,0,0,0,.014-.149.538.538,0,0,0-.026-.139.453.453,0,0,0-.063-.128.613.613,0,0,0-.112-.111.72.72,0,0,0-.121-.082l-.024-.011-.02,0a.375.375,0,0,1-.71-.237.692.692,0,0,1,.076-.176.677.677,0,0,1,.235-.233.792.792,0,0,1,.239-.087.831.831,0,0,1,.282-.015.814.814,0,0,1,.269.091,1.449,1.449,0,0,1,.246.164,1.338,1.338,0,0,1,.245.251,1.2,1.2,0,0,1,.172.341,1.278,1.278,0,0,1,.029.686A.375.375,0,0,1,50.41,68.06Z"
        transform="translate(-7.917 -37.952)"
        fill="currentColor"
      />
      <path
        d="M1.067,1.213a.373.373,0,0,1-.231-.08L-.232.295A.375.375,0,0,1-.295-.232.375.375,0,0,1,.232-.295L1.3.544a.375.375,0,0,1-.232.67Z"
        transform="translate(41.426 28.894)"
        fill="currentColor"
      />
      <path
        d="M0,10.359a.375.375,0,0,1-.334-.2.375.375,0,0,1,.162-.5L19.263-.334a.375.375,0,0,1,.5.162.375.375,0,0,1-.162.5L.171,10.318A.374.374,0,0,1,0,10.359Z"
        transform="translate(42.492 19.748)"
        fill="currentColor"
      />
      <path
        d="M5.211,44.81a.375.375,0,0,1-.375-.375A.685.685,0,0,0,4.746,44a.763.763,0,0,0-.156-.173.716.716,0,0,0-.166-.107L4.393,43.7l0,0a.375.375,0,0,1-.335-.671.752.752,0,0,1,.689,0,1.457,1.457,0,0,1,.329.21,1.51,1.51,0,0,1,.3.334,1.4,1.4,0,0,1,.215.856A.375.375,0,0,1,5.211,44.81Z"
        transform="translate(56.716 -24.687)"
        fill="currentColor"
      />
      <path
        d="M18.824,10.131a.373.373,0,0,1-.172-.042L-.173.333a.375.375,0,0,1-.16-.505.375.375,0,0,1,.505-.16L19,9.423a.375.375,0,0,1-.173.708Z"
        transform="translate(42.797 2.295)"
        fill="currentColor"
      />
      <path
        d="M0,6.4a.375.375,0,0,1-.375-.375V0A.375.375,0,0,1,0-.375.375.375,0,0,1,.375,0V6.021A.375.375,0,0,1,0,6.4Z"
        transform="translate(42.797 1.38)"
        fill="currentColor"
      />
      <path
        d="M47.234,2.68a.375.375,0,0,1-.375-.375,1.006,1.006,0,0,1,.282-.78.974.974,0,0,1,.7-.277A.375.375,0,0,1,47.882,2c-.162.01-.187.035-.211.059s-.062.062-.062.249A.375.375,0,0,1,47.234,2.68Z"
        transform="translate(-4.437 -0.925)"
        fill="currentColor"
      />
      <path
        d="M3.157,25.53a.375.375,0,0,1-.375-.375,1.006,1.006,0,0,1,.281-.78,1.084,1.084,0,0,1,.856-.281.375.375,0,0,1,0,.75c-.264,0-.3.038-.325.061s-.062.062-.062.249A.375.375,0,0,1,3.157,25.53Z"
        transform="translate(58.465 -13.943)"
        fill="currentColor"
      />
      <path
        d="M.909,26.95a.375.375,0,0,1-.375-.375,1.006,1.006,0,0,1,.281-.78,1.006,1.006,0,0,1,.741-.279.375.375,0,0,1,.031.749c-.189.008-.217.036-.241.06s-.062.062-.062.249A.375.375,0,0,1,.909,26.95Z"
        transform="translate(61.78 -14.753)"
        fill="currentColor"
      />
    </g>
  </CameraViewIcon>
);

export default IconDefault;
